import { useCallback } from 'react';
import type { ReportDetail as Detail } from '../../types';
import { track } from '../../services/events';
import { ScoreCard } from './ScoreCard';
import { ArticleResultPanel } from './ArticleResultPanel';
import { ConsultationCard } from './ConsultationCard';

export function ReportDetail({
  report,
  retryingArticleId,
  onRetry
}: {
  report: Detail;
  retryingArticleId: string;
  onRetry: (articleId: string) => void;
}) {
  const expose = useCallback(
    () => track('consult_qr_expose', { view: 'report_detail' }, report.id),
    [report.id]
  );
  const primary = report.articles.find((item) => item.status === 'success') || report.articles[0];
  return (
    <article className="report-detail">
      <div className="report-detail-head">
        <div>
          <h3>{report.task_name || '未命名任务'}</h3>
          <p>
            {report.mode === 'compare' ? '双篇对比' : '单篇评估'} · 关键词：
            {report.keywords?.join('、') || '暂无'}
          </p>
        </div>
        <span className={`status-badge status-${report.status}`}>{report.status}</span>
      </div>
      <div className="report-detail-body">
        <div className="score-panel">
          <ScoreCard report={report} />
          {primary && (
            <div className="summary-box">
              <h4>核心结果</h4>
              <MetricsGridSummary article={primary} mode={report.mode} />
            </div>
          )}
        </div>
        {report.articles.map((article) => (
          <ArticleResultPanel
            key={article.id}
            article={article}
            retrying={retryingArticleId === article.id}
            onRetry={() => onRetry(article.id)}
          />
        ))}
        <ConsultationCard
          consultation={report.consultation}
          reportId={report.id}
          onExpose={expose}
        />
      </div>
    </article>
  );
}
function MetricsGridSummary({
  article,
  mode
}: {
  article: Detail['articles'][number];
  mode: Detail['mode'];
}) {
  return (
    <div className="dimension-list">
      <div className="dimension-row">
        <span>评测模式</span>
        <strong>{mode === 'compare' ? '双篇对比' : '单篇评估'}</strong>
      </div>
      <div className="dimension-row">
        <span>当前文章</span>
        <strong>文章 {article.slot}</strong>
      </div>
      <div className="dimension-row">
        <span>评分等级</span>
        <strong>{article.score_grade || '暂无'}</strong>
      </div>
      <div className="dimension-row">
        <span>AI 引用潜力</span>
        <strong>
          {article.ai_citation_potential_percent == null
            ? '暂无'
            : `${article.ai_citation_potential_percent}%`}
        </strong>
      </div>
    </div>
  );
}
